<template>
    <div>
        <div class="configIndexBox">
            <el-form
                :model="requestData"
                ref="configIndexForm"
                label-width="200px"
                class="listForm"
            >
                <el-form-item v-if="false">
                    <el-input v-model="requestData.id"></el-input>
                </el-form-item>
                <!-- <el-form-item label="回传地址" style="color: #606266;"
                    >{{ clueNotifyUrl }}
                </el-form-item> -->
                <el-form-item label="华为鲸鸿动能" style="color: #606266;"
                    >{{ hwNotifyUrl }}
                    <div class="tips">
                        表单内容【类型：手机号】标题部分内容必须包含’手机‘字样
                    </div>
                </el-form-item>
                <el-form-item label="明讯云业务" style="color: #606266;"
                    >{{ mxNotifyUrl }}
                </el-form-item>
                <el-form-item
                    label="初始密码"
                    style="color: #606266;"
                    prop="initial_password"
                    :rules="[{ required: true, message: '请输入' }]"
                >
                    <el-input
                        v-model="requestData.initial_password"
                        style="width:300px"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="是否开启转接"
                    prop="open_transfer"
                    :rules="[{ required: true, message: '请选择' }]"
                >
                    <el-radio :label="1" v-model="requestData.open_transfer"
                        >开启</el-radio
                    >
                    <el-radio :label="2" v-model="requestData.open_transfer"
                        >关闭</el-radio
                    >
                </el-form-item>
                <el-form-item
                    label="线索分配规则"
                    prop="allocation_rule"
                    :rules="[{ required: true, message: '请选择' }]"
                >
                    <el-radio :label="1" v-model="requestData.allocation_rule"
                        >自行领取</el-radio
                    >
                    <el-radio :label="2" v-model="requestData.allocation_rule"
                        >按顺序分配</el-radio
                    >
                    <el-radio :label="3" v-model="requestData.allocation_rule"
                        >店长指定</el-radio
                    >
                </el-form-item>
                <selectStaff
                    v-if="requestData.allocation_rule != 1"
                    :marginLeft="200"
                    :date="date"
                    @staffCollBack="staff_id = $event"
                ></selectStaff>
                <el-form-item
                    label="待办提醒时间"
                    prop="plan_time"
                    :rules="[{ required: true, message: '请选择' }]"
                >
                    <el-input-number
                        controls-position="right"
                        v-model="requestData.plan_time"
                        :min="0"
                        size="small"
                    ></el-input-number>
                    <div class="tips">单位:分钟</div>
                </el-form-item>
                <el-form-item
                    label="客户到期通知时间"
                    prop="customer_expire_time"
                    :rules="[{ required: true, message: '请选择' }]"
                >
                    <el-input-number
                        controls-position="right"
                        v-model="requestData.customer_expire_time"
                        :min="0"
                        size="small"
                    ></el-input-number>
                    <div class="tips">单位:小时</div>
                </el-form-item>
                <el-form-item
                    label="追加记录时效"
                    prop="customer_expire_time"
                    :rules="[{ required: true, message: '请选择' }]"
                >
                    <el-input-number
                        controls-position="right"
                        v-model="requestData.addition_time"
                        :min="0"
                        size="small"
                    ></el-input-number>
                    <div class="tips">单位:分钟</div>
                </el-form-item>
                <el-form-item
                    label="可置顶标签数量"
                    prop="customer_expire_time"
                    :rules="[{ required: true, message: '请选择' }]"
                >
                    <el-input-number
                        controls-position="right"
                        v-model="requestData.top_label"
                        :min="0"
                        size="small"
                    ></el-input-number>
                    <div class="tips">单位:个</div>
                </el-form-item>

                <el-form-item>
                    <el-button
                        type="primary"
                        size="small"
                        @click="submitForm('configIndexForm')"
                        >保存</el-button
                    >
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
//导入draggable组件
import Draggable from 'vuedraggable'
import selectStaff from '@/components/selectStaff'
export default {
    components: { Draggable, selectStaff },
    data() {
        return {
            requestData: { initial_password: '' },
            // clueNotifyUrl: '',
            hwNotifyUrl: '',
            mxNotifyUrl: '',
            date: [],
            dateRt: [],
            staff_id: [],
        }
    },

    async created() {
        let dynamicConfig = await this.$store.dispatch('dynamicConfig')
        this.date = dynamicConfig.staff
        this.getConfigIndex()
    },
    async mounted() {
        const res = await this.$api.globalConfig({})
        let url = this.$config.request_url
        this.hwNotifyUrl = url + res.hwNotifyUrl
        this.mxNotifyUrl = url + res.mxNotifyUrl
    },
    methods: {
        // 选中
        checked(element) {
            let index = this.dateRt.findIndex((item) => item.uid == element.uid)
            if (index == -1) {
                this.staff_id.push(element.uid)
                this.dateRt.push(element)
            }
        },
        // 开始拖拽事件
        onStart(e) {
            console.log(e)
        },
        // 完成拖拽事件
        onEnd(e) {
            console.log(e)
        },
        // 全选
        allCheck() {
            this.dateRt = JSON.parse(JSON.stringify(this.date))
            this.staff_id = []
            for (let i = 0; i < this.date.length; i++) {
                this.staff_id.push(this.date[i].uid)
            }
        },
        // 取消全选
        unAllCheck() {
            this.dateRt = []
            this.staff_id = []
        },
        // 删除选中
        del(id) {
            let item = this.dateRt.findIndex((i) => {
                return i.uid == id
            })
            let indexCheck = this.staff_id.findIndex((i) => {
                return i == id
            })
            this.dateRt.splice(item, 1)
            this.staff_id.splice(indexCheck, 1)
        },
        //提交信息
        submitForm(formName) {
            let _self = this
            _self.$commonFun.debounce(() => {
                _self.$refs[formName].validate((valid) => {
                    if (valid) {
                        delete _self.requestData.id
                        _self.requestData.staff_id = _self.staff_id || []
                        let param = _self.requestData
                        _self.$api.setMerchantConfig(param).then((res) => {
                            _self.$commonFun.toast('SUCCESS', 'success')
                        })
                    }
                })
            }, 500)
        },
        //获取配置信息
        getConfigIndex() {
            let _self = this
            _self.$api.getMerchantConfig().then((res) => {
                this.requestData = res
                this.staff_id = res.staff_id
                for (var i in this.staff_id) {
                    let index = this.date.findIndex(
                        (res) => res.uid == this.staff_id[i]
                    )
                    if (index != -1) {
                        this.dateRt.push(this.date[index])
                    }
                }
            })
        },
    },
}
</script>

<style lang="scss">
.configIndexBox {
    /*选中样式*/
    .chosen {
        background: #4876ff;
        color: #fff;
    }

    .listForm {
        width: 900px;
    }
    margin-top: 40px;
    height: calc(100vh - 140px);
    overflow-y: auto;
    &::-webkit-scrollbar {
        width: 5px;
        height: 1px;
    }
    &::-webkit-scrollbar-thumb {
        background: #fff;
        border-radius: 30px;
    }
    &::-webkit-scrollbar-track {
        background: #fff;
    }
}
</style>
